import { render } from "./hotQuesView.vue?vue&type=template&id=30c4a008"
import script from "./hotQuesView.vue?vue&type=script&lang=js"
export * from "./hotQuesView.vue?vue&type=script&lang=js"

import "./hotQuesView.vue?vue&type=style&index=0&id=30c4a008&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__